import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { FaEnvelope } from "react-icons/fa";
import Sidebar from "../components/Sidebar";

function Contact() {
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = (e) => {
    e.preventDefault();
    setSent(true);
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <Container className="py-4">
      <Row className="g-4">
        <Col lg={8}>
          <h2 className="block-title">Contact Us</h2>
          <article className="article">
            <div className="article-inner">
              <p>
                Thank you so much for visiting our blog{" "}
                <strong>apkdownloads.net</strong>. If you have any suggestions for
                us, feel free to give your valuable comments or feedback.
              </p>
              <p>
                For any queries or for any other reason, if you want to contact us
                you can reach us by sending an email.
              </p>

              <div className="info-box d-flex align-items-center gap-3">
                <FaEnvelope className="fs-3" style={{ color: "var(--brand)" }} />
                <div>
                  <div className="fw-bold">Email us at</div>
                  <a href="mailto:vootapks@gmail.com">vootapks@gmail.com</a>
                </div>
              </div>

              <h2>Send a message</h2>
              {sent && (
                <Alert variant="success" onClose={() => setSent(false)} dismissible>
                  Thanks! Your message has been sent.
                </Alert>
              )}
              <Form onSubmit={submit}>
                <Row className="g-3">
                  <Col md={6}>
                    <Form.Label>Name</Form.Label>
                    <Form.Control required value={form.name} onChange={update("name")} placeholder="Your name" />
                  </Col>
                  <Col md={6}>
                    <Form.Label>Email</Form.Label>
                    <Form.Control required type="email" value={form.email} onChange={update("email")} placeholder="you@email.com" />
                  </Col>
                  <Col xs={12}>
                    <Form.Label>Message / Feedback</Form.Label>
                    <Form.Control required as="textarea" rows={5} value={form.message} onChange={update("message")} placeholder="Your suggestions or feedback…" />
                  </Col>
                  <Col xs={12}>
                    <Button type="submit" className="btn-brand px-4">Send Message</Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </article>
        </Col>
        <Col lg={4}><Sidebar /></Col>
      </Row>
    </Container>
  );
}

export default Contact;
